import MapsImage from "../../../../../images/Map.svg";
import TicketsRaised from "../../../../../images/TicketsRaised.svg";
import TableFormat from "../../../../../images/TableFormat.svg";

import { useNavigate } from "react-router-dom";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import { MapPageFor } from "../../../../../utils/Enum.types";
import useLabels from "../../../../../customHooks/useLabels";
export enum TabType {
  MAP = "MAP",
  TICKET_RAISED = "TICKET_RAISED",
  ITEMS = "ITEMS",
}
interface Props {
  active: TabType;
  pageFor: MapPageFor;
}
const Tabs = ({ active, pageFor }: Props) => {
  const navigate = useNavigate();

  const { company_id, customer_id, sub_id } = useUrlParams();
  const { itemLabel } = useLabels();
  return (
    <div className="maps__tab">
      <button
        className={`tab-button ${active === TabType.MAP ? "btn-active" : ""}`}
        onClick={() => {
          if (pageFor === MapPageFor.TICKET) {
            navigate(`/${customer_id}/company/${company_id}/ticketing`);
          } else {
            navigate(`/${customer_id}/company/${company_id}/maps`);
          }
        }}
      >
        <img src={MapsImage} alt="" className="icon" />
        Maps
      </button>
      {/* {pageFor === MapPageFor.VIEW ? (
          <>
            <button
              className={`tab-button ${
                active === TabType.ITEMS ? "btn-active" : ""
              }`}
              onClick={() => {
                if (sub_id)
                  navigate(
                    `/${customer_id}/company/${company_id}/subsidiary/${sub_id}/assets`
                  );
                else navigate(`/${customer_id}/company/${company_id}/assets`);
              }}
            >
              <img src={TableFormat} alt="" />
              {itemLabel}
            </button>
          </>
        ) : null} */}
      {pageFor === MapPageFor.TICKET ? (
        <button
          className={`tab-button ${
            active === TabType.TICKET_RAISED ? "btn-active" : ""
          }`}
          onClick={() => {
            if (sub_id)
              navigate(
                `/${customer_id}/company/${company_id}/subsidiary/${sub_id}/raisedticketdetails`
              );
            else
              navigate(
                `/${customer_id}/company/${company_id}/raisedticketdetails`
              );
          }}
        >
          <img src={TicketsRaised} alt="" className="icon" />
          Ticket Raised
        </button>
      ) : null}
    </div>
  );
};

export default Tabs;
